/**
 * Project client
 *
 * Created by stefensuhat on 01/09/18 1.45 PM
 */

import { CircularProgress, makeStyles, Typography, useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    label: PropTypes.string,
    color: PropTypes.oneOf('primary', 'secondary'),
    size: PropTypes.number,
};
const defaultProps = {
    color: 'primary',
    label: '',
    size: 24,
};

const styles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        // justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        margin: theme.spacing(5),
        // minHeight: '100vh',
    },
    text: {
        letterSpacing: 1.5,
    },
    // spinnerWrapper: {
    //     minWidth: 50,
    // },
    // Reproduce the Facebook spinners.
    facebook: {
        // margin: theme.spacing(2),
        position: 'relative',
    },
    facebook1: {
        color: '#EEF3FD',
    },
    facebook2: {
        color: theme.palette.secondary.light,
        animationDuration: '550ms',
        position: 'absolute',
        left: 0,
    },
}));

function Progress({ label, size, color }) {
    const classes = styles();
    const theme = useTheme();

    return (
        <div className={classes.root}>
            <CircularProgress size={20} color={color} />

            {/* <div className={classes.facebook}> */}
            {/*    <CircularProgress */}
            {/*        variant="determinate" */}
            {/*        value={100} */}
            {/*        className={classes.facebook1} */}
            {/*        size={size} */}
            {/*        thickness={4} */}
            {/*    /> */}
            {/*    <CircularProgress */}
            {/*        variant="indeterminate" */}
            {/*        disableShrink */}
            {/*        className={classes.facebook2} */}
            {/*        size={size} */}
            {/*        thickness={4} */}
            {/*    /> */}
            {/* </div> */}

            {label && (
                <Typography
                    gutterBottom
                    variant="overline"
                    className={classes.text}
                >
                    {label}
                </Typography>
            )}
        </div>
    );
}

Progress.propTypes = propTypes;
Progress.defaultProps = defaultProps;

export default Progress;
